import { render, staticRenderFns } from "./signup-overseas.vue?vue&type=template&id=2619ccbe&scoped=true"
import script from "./signup-overseas.vue?vue&type=script&lang=js"
export * from "./signup-overseas.vue?vue&type=script&lang=js"
import style0 from "./signup-overseas.vue?vue&type=style&index=0&id=2619ccbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2619ccbe",
  null
  
)

export default component.exports